export const URL = {
   HOME: '/',
   LOGIN: '/login',
   CHANNEL: '/inbox/hub/channel',
   CHANNEL_FACEBOOK: '/inbox/hub/channel/facebook',
   POSTS_COMMENTS_SALE_POSTS_SETTING: '/posts_comments/sale_post/default_settings',
   POSTS_COMMENTS_SALE_POSTS_SETTING_CAMPAIGN: '/posts_comments/sale_post/default_settings/campaign/:id',
   POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST: '/posts_comments/sale_post/campaign_list',
   POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_EDIT: '/posts_comments/sale_post/campaign_list/edit/:id',
   POSTS_COMMENTS_POSTS_POSTS_LIST: '/posts_comments/posts/postlist',
   POSTS_COMMENTS_POSTS_POSTS_LIST_EDIT: '/posts_comments/posts/postlist/:id',
   POSTS_COMMENTS_AUTOCOMMENT_KEYWORD: '/posts_comments/autocomment/keyword',
   SHOPPING_CART: '/shopping-carts/:id',
   DETAIL_CART: '/shopping-cart-detail/:id',
   SHOPPING_CART_PAYMENT: '/shopping-cart-detail/payment/:id',
   SHOPPING_CART_THANK_YOU: '/shopping-cart-detail/thank_you/:id',
   SHOPPING_CART_PAY_RESULT: '/shopping-cart-detail/payment_result',
   PAGE_POLICY: '/pages/policy',
   PAGE_QD: '/pages/quy-dinh',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL: '/chat_assistant/messenger_settings/general',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ: '/chat_assistant/messenger_settings/faq',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT: '/chat_assistant/messenger_settings/faq/flow/edit/:id',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU: '/chat_assistant/messenger_settings/mainmenu',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY: '/chat_assistant/messenger_settings/defaultreply',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE: '/chat_assistant/messenger_settings/welcomemessage',
   CHAT_ASSISTANT_MESSENGER_SETTINGS_INSTAGRAM: '/chat_assistant/messenger_settings/instagram',
   CHAT_ASSISTANT_CONVERSATION_GENERAL: '/chat_assistant/conversation/general',
   CHAT_ASSISTANT_CONVERSATION_COMMENT: '/chat_assistant/conversation/comment',
   CHAT_ASSISTANT_CONVERSATION_TAGLIST: '/chat_assistant/conversation/taglist',
   CHAT_ASSISTANT_CONVERSATION_TAGFOLDER: '/chat_assistant/conversation/tagfolder',
   CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION: '/chat_assistant/conversation/tagextension',
   CHAT_ASSISTANT_SETUP_KEYWORD: '/chat_assistant/setup/keyword',
   CHAT_ASSISTANT_SETUP_REF: '/chat_assistant/setup/ref',
   CHAT_ASSISTANT_SETUP_SEQUENCE: '/chat_assistant/setup/sequence',
   CHAT_ASSISTANT_SETUP_TRIGGER: '/chat_assistant/setup/trigger',
   CHAT_ASSISTANT_CONTENT_FLOW: '/chat_assistant/content/flow',
   CHAT_ASSISTANT_CHAT_HINT: '/chat_assistant/chat_hint',
   CHAT_ASSISTANT_CONNECTION_STATUS: '/chat_assistant/connection_status',
   LIVESTREAM_LIVE_CAMPAIGN_LIST: '/livestream/live_campaign_list',
   LIVESTREAM_LIVE_CAMPAIGN_LIST_EDIT: '/livestream/live_campaign_list/edit/:id',
   LIVESTREAM_LIVE_CAMPAIGN_LIST_DEFAULT_SETTINGS: '/livestream/live_campaign_list/default_settings',
   LIVESTREAM_LIVE_CAMPAIGN_LIST_SETTING_CAMPAIGN: '/livestream/live_campaign_list/default_settings/campaign/:id',
   INTRO: '/intro',
   TASK_MANAGEMENT: '/task_management',
   INBOX: '/inbox',
   CUSTOMER_ALL : '/customer/all',
   UPLOAD_VIDEO: '/upload/video',
   LIVE_VIDEO_ON_PAGE: '/livestream/live_video_on_page',
   SUPPORT_LIVESTREAM: '/support/livestream',
}

export const URL_CHANNEL = [
   URL.CHANNEL,
   URL.CHANNEL_FACEBOOK,
   URL.INTRO,
];

export const URL_HIDEN_MENU = [
   URL.SHOPPING_CART,
   URL.DETAIL_CART,
   URL.SHOPPING_CART_PAYMENT,
   URL.SHOPPING_CART_THANK_YOU,
   URL.SHOPPING_CART_PAY_RESULT,
   URL.LOGIN,
   URL.PAGE_POLICY,
   URL.PAGE_QD,
   URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_EDIT,
   URL.SUPPORT_LIVESTREAM
]